import styles from './license-plate-list.module.sass';
import isEmpty from 'lodash/fp/isEmpty';
import { LicensePlateListItem } from './license-plate-list-item';

export const LicensePlateList = ({ enterpriseTaxSettings, licensePlates, user }) => {
  if (isEmpty(licensePlates)) {
    return <div className={styles['empty-state']}>找不到與搜尋條件相符的車牌，請重新嘗試。</div>;
  }

  return (
    <ul className={styles['license-plate-list']}>
      {licensePlates.map(
        ({
          id,
          plateNumber,
          vehicleType,
          oilType,
          cityParkinglots,
          energySource,
          mochipassEnable,
          currentTaxIdNumber,
        }) => (
          <LicensePlateListItem
            key={id}
            licensePlateId={id}
            plateNumber={plateNumber}
            vehicleType={vehicleType}
            oilType={oilType}
            taipeiParkingBindingStatus={cityParkinglots['taipeiCity'].state}
            energySource={energySource}
            isMochipassEnable={mochipassEnable}
            taxSetting={enterpriseTaxSettings.find(({ taxIdNumber }) => taxIdNumber === currentTaxIdNumber)}
            isAutoSyncLicensePlateMochipass={!!user?.autoSyncLicensePlateMochipass}
            hasUserAgreedTermsOfTaipeiParkingService={user?.cities.taipeiCity.agreeTermsOfParkinglotService}
          />
        )
      )}
    </ul>
  );
};
